<div bsModal #subscriptionSuccessModal="bs-modal" class="modal fade center-modal-specific"
  [config]="{keyboard: false, backdrop: 'static'}" id="VFPremium" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered adjust-users-modal modal-dialog-scrollable">
    <div class="modal-content rounded-5 bg-popup box-shadow-popup border-all">
      <div class="modal-body text-center">
        <div class="row d-flex justify-content-center mt-3 pb-3 border-bottom">
          <span class="tk-montserrat f-size-50 font-weight-bold text-vf-dark">Welcome to <img src="https://cdn.trovve.com/trovve/Logo dark 150px.svg" class="welcome-to-company-logo"></span>
        </div>
        <p class="f-size-18 my-4 text-vf-medium">Thank you for subscribing to the <b>{{planName}} Plan!</b> 
          <br>You've taken the first step towards superhuman productivity.
        </p>
        <div class="row justify-content-center">
          <div class="welcome-options">
            <div class="welcome-option">
              <lucide-icon name="rocket" [size]="16" [strokeWidth]="2" class="text-vf-dark mr-2"></lucide-icon> <span class="font-weight-bold mr-2"> Get started:</span>
              <span class="f-size-14">Check out our <a class="btn-link text-blue text-underline" href="https://www.youtube.com/channel/UCBv1H4cRIdvxcGqDq0Phlkg" target="_blank">quick overview</a> to hit the ground running!</span>
            </div>
            <div class="welcome-option">
              <lucide-icon name="rocket" [size]="16" [strokeWidth]="2" class="text-vf-dark mr-2"></lucide-icon> <span class="font-weight-bold mr-2"> Stay informed:</span>
              <span class="f-size-14">Keep an eye on your inbox for tips, updates, and exclusive offers.</span>
            </div>
            <div class="welcome-option">
              <lucide-icon name="rocket" [size]="16" [strokeWidth]="2" class="text-vf-dark mr-2"></lucide-icon> <span class="font-weight-bold mr-2"> Need Assistance?</span>
              <span class="f-size-14">Our <a class="btn-link text-blue text-underline" href="https://forms.office.com/pages/responsepage.aspx?id=pgyIyWmlpkOJI1BwUax7G-aKh0QROtJBnWlce0FUzcFUMjVXTk1PWVZHMzBJSkhIN0taQVIwRFlaSi4u&origin=lprLink" target="_blank">support team</a> is here to ensure your experience is seamless.</span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer text-center">
        <div class="row">
          <div class="col">
            <button
              class="btn btn-black f-size-16 px-4 rounded-24 hover-shadow py-10 tk-proxima-nova font-weight-normal"
              (click)="sendToSettings()">Launch Trovve <lucide-icon name="chevron-right" [size]="16" [strokeWidth]="2" class="ml-2"></lucide-icon></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>